import debounce from "lodash.debounce";
import { useCallback, useState } from "react";
import { styled } from "styled-components";

import { UIInput } from "common/components/form/UIInput";
import { useTranslate } from "common/utilities/useTranslate";

const StyledSearch = styled(UIInput)`
  margin-bottom: 2rem;
`;

type TopicSearchBarProps = {
  dataTestId?: string;
  defaultValue?: string | undefined;
  isPending: boolean;
  onSearch: (query: string) => void;
};

export const TopicSearchBar = ({ isPending, defaultValue, onSearch, dataTestId }: TopicSearchBarProps) => {
  const translate = useTranslate();
  const [query, setQuery] = useState(defaultValue);

  const onSearchHandle = (searchTerm: string) => {
    setQuery(searchTerm);
    debouncedOnSearch(searchTerm);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedOnSearch = useCallback(debounce(onSearch, 500), []);

  const onClearHandle = () => onSearchHandle("");

  return (
    <StyledSearch
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={false}
      clear={onClearHandle}
      data-test-id={dataTestId}
      isPending={isPending}
      name="searchQuery"
      onChange={onSearchHandle}
      placeholder={translate("app.discover.topic.tabs.knowledge.filter.search_title")}
      value={query ?? ""}
    />
  );
};
